import { ExternalLink } from 'assets/icons';
import { isDeletedGroupLink, markDeletedGroup, useLinkLabel } from 'components/record/deletedGroup';
import useText from 'hooks/useText';
import LINK_ICONS from '../linkIcons';

// The line under a link's name. A contact gives its role, its company and how
// to reach it: the task's own for its first contact, its company's for a task
// without links (as before). Another record says what it is.
const detailOf = (link, task, text) => {
  const legacy = !task.links?.length;
  if (link.type === 'contact') {
    const own = link.label === task.contactName;
    return legacy
      ? [task.company?.contactRole, link.sub, task.company?.phone]
      : [own && task.contactRole, link.sub, own && task.contactDetail];
  }
  if (legacy && link.type === 'company') return [task.company?.phone];
  return [text(`linkKind_${link.type}`), link.sub];
};

/**
 * One record a task is linked to, a line of the « Lié à » list: the icon of
 * its kind (as in the table), its name, what it is. The whole line opens the
 * record (none without `onOpen`, nor for a deleted group).
 */
const TaskContactCard = ({ link: given, task, onOpen }) => {
  const { text } = useText('taskPanel');
  const linkLabel = useLinkLabel();
  const link = markDeletedGroup(task)(given);
  const deleted = isDeletedGroupLink(link);
  const Icon = LINK_ICONS[link.type];
  const detail = detailOf(link, task, text).filter(Boolean).join(' · ');
  const content = (
    <>
      <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md border border-gray-100 bg-white text-gray-600">
        {Icon && <Icon wh={16} color="currentColor" />}
      </span>
      <span className="min-w-0 flex-1">
        <span className="flex min-w-0 items-center gap-2">
          <span className={`truncate text-sm font-medium ${deleted ? 'text-gray-400' : 'text-gray-900'}`}>{linkLabel(link)}</span>
        </span>
        {detail && <span className="block truncate text-xs text-gray-500">{detail}</span>}
      </span>
    </>
  );
  if (!onOpen || deleted) return <div className="flex items-center gap-3 px-3 py-2.5">{content}</div>;
  return (
    <button
      type="button"
      onClick={onOpen}
      aria-label={`${text('fiche')} · ${link.label}`}
      className="group flex w-full items-center gap-3 px-3 py-2.5 text-left transition-colors hover:bg-gray-50"
    >
      {content}
      <span className="shrink-0 text-gray-400 transition-colors group-hover:text-gray-700">
        <ExternalLink wh={16} color="currentColor" />
      </span>
    </button>
  );
};

export default TaskContactCard;
